import { convertTokenPrice } from '@/utils/apiEndpoints'

export class PriceConverter {
  static async convertToTokenUnits(usd, token) {
    const r = await convertTokenPrice({
      chainId: token.chainId,
      token: token.address ? token.address : token,
      usd,
    })
  
    if (r.result && r.result.units) {
      return BigInt(r.result.units)
    }
    return BigInt(0)
  }
}
